import { createI18nText } from '@hilma/netina2all';

const purchaseAssociationText = createI18nText({
    he: {
        allAssociations: 'חלוקה לכל העמותות',
        associations: 'עמותות',
        wereFound: 'נמצאו',
        changeChoice: 'שנה בחירה',
        error: 'יש לבחור בעמותה או חלוקה לכל העמותות'
    },
    en: {
        allAssociations: 'Distribution to all the associations',
        associations: 'associations',
        wereFound: 'were found',
        changeChoice: 'Change choice',
        error: 'Please choose an association or choose distribution to all the associations'
    }
});

export default purchaseAssociationText;